import { Dialog, styled } from '@mui/material'
import useScreenWidth from '../hooks/useScreenWidth'

interface StyledDialogProps {
  open: boolean
  children?: React.ReactNode
  onClose: () => void
  'aria-labelledby': string
  'aria-describedby': string
  disableEnforceFocus?: boolean
}

export const StyledDialog = styled((props: StyledDialogProps) => {
  const isMobile = useScreenWidth(700)
  return <Dialog fullWidth={true} fullScreen={isMobile && true} maxWidth={!isMobile && 'md'} {...props} />
})(({ theme }) => ({
  '& .MuiDialog-paperScrollPaper': {
    overflow: 'hidden',
    width: '100%'
  },
  '& .dzu-dropzone': {
    overflow: 'auto',
    width: 'auto !important',
    height: '100%'
  },
  '& .dzu-inputLabel': {
    color: theme.palette.primary.light,
    '&:active': {
      backgroundColor: theme.palette.grey[100]
    },
    '&:hover': {
      backgroundColor: theme.palette.grey[100]
    }
  },
  '& .MuiFormControl-root': {
    marginBottom: '0px'
  },
  '& .Mui-error': {
    borderColor: theme.palette.warning.main,
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.main
  },
  '& p.Mui-error': {
    backgroundColor: theme.palette.common.white
  }
}))
